<app-navbar title="Dodawanie wydarzenia transportowego">
	<button class="btn btn-primary me-2" (click)="submit()">Zapisz</button>
	<a routerLink="/tourism-calendar/" class="btn btn-danger"> <i class="far fa-calendar-alt"></i> Kalendarz </a>
</app-navbar>

<div class="container">
	<form class="my-4">
		<div class="form-floating mb-3">
			<input
				class="form-control"
				id="name"
				name="name"
				[(ngModel)]="event.name"
				[ngClass]="{ error: this.errors.name }"
			/>
			<label for="name">Nazwa wydarzenia</label>
		</div>
		<div class="row mb-3">
			<div class="col-4">
				<div class="form-floating">
					<input
						type="datetime-local"
						class="form-control"
						name="date_from"
						id="date_from"
						[appUtcModel]="event.date_from"
						(appUtcModelChange)="calculateDates($event)"
						[ngClass]="{ error: this.errors.date_from }"
					/>
					<label for="date_from">Data rozpoczęcia</label>
				</div>
			</div>
			<div class="col-4">
				<div class="form-floating">
					<input
						type="datetime-local"
						class="form-control"
						name="date_to"
						id="date_to"
						[appUtcModel]="event.date_to"
						(appUtcModelChange)="
							event.date_to = $event; calculateDateDeadline(); calculateDateAuto(); calculateEndDate()
						"
						[ngClass]="{ error: this.errors.date_to }"
					/>
					<label for="date_to">Data zakończenia</label>
				</div>
			</div>
			<div class="col-4">
				<div class="form-floating">
					<input
						type="datetime-local"
						class="form-control"
						name="date_deadline"
						id="date_deadline"
						[appUtcModel]="event.date_deadline"
						(appUtcModelChange)="event.date_deadline = $event"
						[readonly]="event.dateDeadlineAuto"
					/>
					<label for="date_deadline">Data potwierdzenia</label>
				</div>
				<div class="form-check mb-3">
					<input
						class="form-check-input"
						type="checkbox"
						name="dateDeadlineAuto"
						[ngModel]="event.dateDeadlineAuto"
						id="dateDeadlineAuto"
						(ngModelChange)="calculateDateDeadline()"
						[disabled]="!auth.permissionsByCode()[Permissions.VEHICLES_EVENTS_DISABLE_AUTO_DATES_CONFIRMS]"
					/>
					<label class="form-check-label" for="dateDeadlineAuto"> Automatyczna data potwierdzenia </label>
				</div>
			</div>
		</div>
		<div class="form-floating mb-3">
			<select class="form-select" id="status" name="status" [(ngModel)]="event.status">
				@for (item of statuses; track item.id) {
					<option [value]="item.id">
						{{ item.name }}
					</option>
				}
			</select>
			<label for="status">Status</label>
		</div>
		<div class="mb-3">
			<app-tourism-events-vehicle-add
				[min]="event.date_from"
				[max]="event.date_to"
				[vehicles]="vehicles"
				[editable]="lockEdit"
				[alreadyAddedVehicles]="event.vehicles"
				(emitVehiclesArray)="setVehicles($event); addVirtualDriver($event)"
			></app-tourism-events-vehicle-add>
		</div>
		<div class="mb-3">
			<label class="form-label" for="owner">Opiekun</label>
			<ng-select
				id="owner"
				name="owner"
				[(ngModel)]="event.owner"
				placeholder="(wybierz)"
				bindLabel="name"
				[multiple]="true"
				[ngClass]="{ error: this.errors.owner }"
				required
			>
				@for (item of users; track item.id) {
					<ng-option [value]="item.id">{{ item.name }}</ng-option>
				}
			</ng-select>
		</div>
		<div class="mb-3">
			<label class="form-label" for="programWyjazdu">Program wyjazdu</label>
			<ckeditor
				id="programWyjazdu"
				name="programWyjazdu"
				[(ngModel)]="event.text_program"
				[editor]="editor"
				[config]="editorConfig"
			></ckeditor>
		</div>
		<div class="mb-3">
			<label class="form-label">Klient</label>
			<app-tourism-events-organization
				[client]="event.client"
				(clientData)="sendData($event)"
			></app-tourism-events-organization>
		</div>
		<div class="card mb-3">
			<div class="card-body">
				<div class="row col-7">
					<div class="col">
						<label class="form-label text-start">Kierowcy wyjazd</label>
					</div>
				</div>
				@for (driver of event.drivers_departure; track driver.id; let driverIndex = $index) {
					<div class="row mt-2">
						<div class="col">
							<label for="program_date_from">Kierowca</label>
							<ng-select
								name="driversDeparture_{{ driverIndex }}"
								[ngModel]="event.drivers_departure[driverIndex].driver"
								placeholder="(wybierz)"
								bindLabel="name"
								[disabled]="lockEdit || driver?.confirmed"
								(ngModelChange)="changeDriverDeparture($event, driver, event, driverIndex)"
								(focus)="onFocusedDriver(event.drivers_departure[driverIndex].driver)"
							>
								@for (item of drivers; track item.id) {
									<ng-option [value]="item.id">{{ item.last_name }} {{ item.first_name }}</ng-option>
								}
							</ng-select>
							@if (lockEdit) {
								<a class="cursor-pointer" (click)="driverModalOpen(driver)">Czas pracy kierowcy</a>
							}
						</div>
						<div class="col">
							<label for="drivers_departure_{{ driverIndex }}_date_from">Data od</label>
							<input
								type="datetime-local"
								class="col-sm-2 form-control"
								name="drivers_departure_{{ driverIndex }}_date_from"
								id="drivers_departure_{{ driverIndex }}_date_from"
								[appUtcModel]="driver.date_from"
								(appUtcModelChange)="driver.date_from = $event; checkEditedDriverDocument(event)"
								[readonly]="driver.dateFromAuto"
								[disabled]="lockEdit || driver?.confirmed"
							/>
							<div class="col form-check mt-1">
								<input
									class="form-check-input"
									type="checkbox"
									[ngModel]="driver.dateFromAuto"
									(ngModelChange)="checkAutoDate(driver, 'date_from', $event)"
									name="drivers_departure_{{ driverIndex }}_dateFromAuto"
									id="drivers_departure_{{ driverIndex }}_dateFromAuto"
									[disabled]="lockEdit || driver?.confirmed"
								/>
								<label class="form-check-label" for="drivers_departure_{{ driverIndex }}_dateFromAuto">
									Automatyczna "Data od"
								</label>
							</div>
						</div>
						<div class="col">
							<label for="drivers_departure_{{ driverIndex }}_date_to">Data do</label>
							<input
								type="datetime-local"
								class="col-sm-2 form-control"
								name="drivers_departure_{{ driverIndex }}_date_to"
								id="drivers_departure_{{ driverIndex }}_date_to"
								[appUtcModel]="driver.date_to"
								(appUtcModelChange)="driver.date_to = $event; checkEditedDriverDocument(event)"
								[readonly]="driver.dateToAuto"
								[disabled]="lockEdit || driver?.confirmed"
							/>
							<div class="col form-check mt-1">
								<input
									class="form-check-input"
									type="checkbox"
									[ngModel]="driver.dateToAuto"
									(ngModelChange)="checkAutoDate(driver, 'date_to', $event)"
									name="drivers_departure_{{ driverIndex }}_dateToAuto"
									id="drivers_departure_{{ driverIndex }}_dateToAuto"
									[disabled]="lockEdit || driver?.confirmed"
								/>
								<label class="form-check-label" for="drivers_departure_{{ driverIndex }}_dateToAuto">
									Automatyczna "Data do"
								</label>
							</div>
						</div>
						<div class="col">
							@if (!driver.confirmed && !lockEdit) {
								<div class="btn btn-danger mt-4" (click)="deleteDriver('drivers_departure', driver)">
									Usuń kierowce
								</div>
							}
							<div class="mt-4">
								@if (lockEdit) {
									<a
										target="_blank"
										routerLink="/drivers-calendar/{{ driver.date_from | date: 'yyyy-MM-dd' }}"
										[fragment]="driver.driver"
									>
										<i class="far fa-calendar-alt"></i>
									</a>
								}
							</div>
						</div>
					</div>
				}
				<div class="row">
					<div class="col mt-2">
						@if (!lockEdit) {
							<div class="btn btn-primary" (click)="driverAddRow('drivers_departure')">
								Dodaj kierowce
							</div>
						}
					</div>
				</div>
			</div>
		</div>
	</form>
</div>
<br />
